import {DeliveryStepFormFieldType} from 'desktop/pages/checkout/types/checkoutTypes';

/**
 * Returns correct address string using received address components
 * @param {string} componentValue - Address component to concatenation with address value
 * @returns {DeliveryStepFormFieldType} - Returned address value
 */
export const getPostalModifier = (
    currentValue: string,
    componentValue: string,
): DeliveryStepFormFieldType => ({
    error: false,
    success: true,
    value: currentValue ? `${currentValue}-${componentValue}` : componentValue,
});
